import type { TFunction } from "i18next";
import type { Decision } from "../../api/access/decisions";
import { decisionReason } from "./refusalWords";

/**
 * How a control shows the served decision it requires (`requires`, accounts.md GS-8, redesign
 * R3-5): refused about where things are (`state`), it isn't shown; refused about the person or
 * what must happen first (`viewer`, `prerequisite`), it is shown disabled with why, and a
 * permission one lacks, with what would open it, opens BlockedState.
 */
export type Requirement =
  | { readonly shown: false }
  | { readonly shown: true; readonly reason: string | null; readonly blocked: Decision | null };

export function requirementOf(t: TFunction, decision: Decision): Requirement {
  if (decision.refusal === null) return { shown: true, reason: null, blocked: null };
  if (decision.concern === "state") return { shown: false };
  const blocked = decision.refusal === "missing_permission" && decision.remedy !== null ? decision : null;
  return { shown: true, reason: decisionReason(t, decision), blocked };
}
